import * as React from 'react'

export const IconInternet = () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12 22c2.05 0 3.812-2.468 4.584-6h4.584c.277-.635.49-1.304.632-2h-4.9a19.855 19.855 0 0 0 0-4h4.9a9.927 9.927 0 0 0-.632-2h-4.584C15.812 4.468 14.05 2 12 2S8.188 4.468 7.416 8H2.832a9.925 9.925 0 0 0-.632 2h4.9a19.832 19.832 0 0 0 0 4H2.2c.141.696.355 1.365.632 2h4.584c.772 3.532 2.534 6 4.584 6Zm2.53-6c-.209.83-.477 1.564-.783 2.177C12.948 19.774 12.215 20 12 20c-.215 0-.948-.226-1.747-1.823A10.785 10.785 0 0 1 9.47 16h5.06Zm-.783-10.177c.306.613.574 1.348.783 2.177H9.47c.209-.83.477-1.564.783-2.177C11.052 4.226 11.785 4 12 4c.215 0 .948.226 1.747 1.823ZM15 12c0-.695-.04-1.364-.111-2H9.11A17.735 17.735 0 0 0 9 12c0 .695.04 1.364.111 2h5.777c.073-.636.112-1.305.112-2Z'
      fill='#EEE6EF'
    />
  </svg>
)
